import React, { forwardRef } from 'react'
import cx from 'classnames'

const Gutter = forwardRef(({
  isVertical,
  className,
  size,
  ...props
}: {
  isVertical?: boolean
  className: string,
  size: number
}, ref: any) => {
  const classes = cx(className)
  const sizeProp = isVertical ? 'height' : 'width'

  return (
    <div
      style={{ [sizeProp]: `${size}px` }}
      className={classes}
      ref={ref}
      {...props}
    />
  )
})

Gutter.defaultProps = {
  isVertical: false,
}

export default Gutter
